import { render, staticRenderFns } from "./EatingExperienceCard.vue?vue&type=template&id=6fa86e8f&scoped=true&"
import script from "./EatingExperienceCard.vue?vue&type=script&lang=js&"
export * from "./EatingExperienceCard.vue?vue&type=script&lang=js&"
import style0 from "./EatingExperienceCard.vue?vue&type=style&index=0&id=6fa86e8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa86e8f",
  null
  
)

export default component.exports